import { render, staticRenderFns } from "./TabsContainer.vue?vue&type=template&id=1c757903&scoped=true&"
import script from "./TabsContainer.vue?vue&type=script&lang=js&"
export * from "./TabsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TabsContainer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabsContainer.vue?vue&type=style&index=1&id=1c757903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c757903",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c757903')) {
      api.createRecord('1c757903', component.options)
    } else {
      api.reload('1c757903', component.options)
    }
    module.hot.accept("./TabsContainer.vue?vue&type=template&id=1c757903&scoped=true&", function () {
      api.rerender('1c757903', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/TabsContainer.vue"
export default component.exports